import { dashboardPagePath } from 'components/navigation/paths';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@vwfs-bronson/bronson-react';
import { useHistory } from 'react-router-dom';

export const EarlyReturnPenaltyModal: React.FC<{
    status?: 'success' | 'error' | 'inProgress';
    onModalClose: () => void;
    textKey?: string | null;
}> = ({ status, onModalClose, textKey }) => {
    const { t } = useTranslation('early-return-penalty');
    const history = useHistory();

    if (!status) return null;

    return (
        <Modal
            shown={textKey !== 'missingEmail' && (status === 'success' || status === 'error')}
            status={status === 'inProgress' ? 'info' : status}
            onClose={status === 'success' ? (): void => history.push(dashboardPagePath()) : onModalClose}
            onCancel={(): void => history.push(dashboardPagePath())}
            buttonCancelText={t('modal.button')}
            title={status === 'success' ? t(`modal.${status}.title`) : ''}
            testId={`${status}-modal`}
            {...(status === 'success' && { 'aria-live': 'polite', role: 'status', 'aria-atomic': 'true' })}
        >
            <div dangerouslySetInnerHTML={{ __html: t(`modal.${status}.${textKey ?? 'text'}`) }} />
        </Modal>
    );
};
